import jwtDecode from 'jwt-decode';
import { sessionStoragePRO } from '../constants/globals';
import moment from 'moment';

export const extractAccessToken = () => {
  const tokenObject = parseTokenToJSON();
  return tokenObject?.access_token;
};

export const dateNow = moment(Date.now()).format('DD MM YYYY hh:mm:ss');

export const tokenBeforeExpirationCheck = () => {
  const tokenObject = parseTokenToJSON();
  return (
    tokenObject &&
    jwtDecode(extractAccessToken()).exp * 1000 - 1000 * 60 * 10 < Date.now()
  );
};

function parseTokenToJSON() {
  const tokenJSON = sessionStorage[sessionStoragePRO];
  return tokenJSON ? JSON.parse(tokenJSON) : '';
}

export const tokenExpirationCheck = () => {
  const tokenObject = parseTokenToJSON();
  return (
    tokenObject && jwtDecode(extractAccessToken()).exp * 1000 <= Date.now()
  );
};
